import React, { Component } from 'react';
import { Image } from 'semantic-ui-react'
import './ConfirmationPage.css';
import checkcomplete from '../img/checkcomplete.png';
import ProHeader from './Pro/ProHeader';
import ProFooter from './Pro/ProFooter';
import RHHeader from './Corp/RHHeader';
import RHFooter from './Corp/RHFooter';
import RHHeaderField from './Field/RHHeaderField';
import RHFooterField from './Field/RHFooterField';
import { translationsV2 } from '../translations';

class OptOutConfirmation extends Component {

    state = {
        userRole: '',
        region: '',
        country: '',
        translations: {
        },
    }

    componentDidMount() {
        if (this.props.location.state) {
            this.setState({
                userRole: this.props.location.state.passedUserRole,
                country: this.props.location.state.passedCountry,
                region: this.props.location.state.passedregion,
            }, () => {
                console.log(this.state.userRole);

                const country = this.state.country;

                // Load translations based on the country
                let translations = this.getTranslationsBasedOnCountry(country);
                if (translations) {
                    this.setState({
                        translations: translations
                    });
                }
            });
        }
        else {
            this.props.history.push('./unauthorized');
        }
    }

    getTranslationsBasedOnCountry(country) {
        const translations = translationsV2.find(t => t.language === country);
        if (translations) {
            return translations.translations;
        }
        return translationsV2.find(t => t.country === "United States").translations;
    }

    handleHeaderSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProHeader />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHHeader />;
        else if (this.state.userRole === 'FIELD')
            return <RHHeaderField />;
    }

    handleFooterSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProFooter />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHFooter />;
        else if (this.state.userRole === 'FIELD')
            return <RHFooterField />;
    }

    handlEneaEmail() {
        if (this.state.region === 'EMEA')
            return (
                <p className="confirmation-description">{this.state.translations.optOutConfirmationMessage1} <br /><br />{this.state.translations.optOutConfirmationMessage2} <a href='mailto:AssetsManagementRegistrationSite@roberthalf.net'><em>EMEA Asset Management Team</em></a></p>
            )
    }

    handleUserRole() {
        if (this.state.region === 'NA' && this.state.userRole === 'PROTIVITI')
            return (
                <p className="confirmation-description">You have successfully Opted-out from upgrading your Protiviti computer. You will receive an email confirmation shortly.<br /><br />
                    If you have any questions, please contact: <br /> <a href='mailto:NAProtivitiUpgrades@protiviti.com'><em>NAProtivitiUpgrades@protiviti.com</em></a></p>
            )
        else if (this.state.region === 'NA' && this.state.userRole === 'CORPORATE')
            return (
                <p className="confirmation-description">You have successfully Opted-out from upgrading your Robert Half computer. You will receive an email confirmation shortly.<br /><br />
                   If you have any questions, please contact <br /> <a href='mailto:Upgrades@roberthalf.com'><em>Upgrades@roberthalf.com</em></a>.</p>
            )
        else if (this.state.region === 'NA' && this.state.userRole === 'FIELD')
            return (
                <p className="confirmation-description">You have successfully Opted-out from upgrading your Robert Half computer. You will receive an email confirmation shortly.<br /><br />
                    If you have any questions, please contact <br /> <a href='mailto:spgrades@roberthalf.com'><em>upgrades@roberthalf.com</em></a>.</p>
            )
    }
    
    render() {
        return (
            <div className='outer-container'>
                <div className='inner-container'>
                    {this.handleHeaderSelection()}

                    <div className="confirmation-container">

                        <Image src={checkcomplete} className="check-complete-img" />
                        <p className="thank-you">{this.state.translations.optOutConfirmationThankYou}</p>
                        {this.handleUserRole()}
                        {this.handlEneaEmail()}
                    </div>
                </div>
                {this.handleFooterSelection()}

            </div>

        );
    }
}


export default OptOutConfirmation;
